/*
 * Jira Ticket:
 * Created Date: Mon, 20th Apr 2020, 18:02:15 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import axios from 'axios';

// File upload response structure
// type UploadTowerFileResponse {
//   files: [FileUpload!]!
// }
// type FileUpload {
//   id: ID!
//   url: URL!
//   uploadUrl: URL!
//   contentType: String!
// }

const UploadTowerFileMutation = gql`
  mutation uploadTowerFile($input: UploadTowerFileInput) {
    data: uploadTowerFile(input: $input) {
      files {
        id
        url
        uploadUrl
        contentType
      }
    }
  }
`;

export default async ({ client, files }) => {
  // File upload request structure
  // input: {files: [FileUploadInput] }
  // input FileUploadInput {
  //     filename: String!
  //     contentType: String
  //   }
  const rawFiles = files.filter(file => file.hasOwnProperty('rawFile'));
  const input = {
    files: rawFiles.map(file => {
      return { filename: file.rawFile.name, contentType: file.rawFile.type };
    }),
  };
  if (input.files.length > 0) {
    const uploadRequest = await client.mutate({
      mutation: UploadTowerFileMutation,
      variables: {
        input,
      },
    });
    const responseFiles = uploadRequest.data.data.files;
    const putRequests = [];
    for (let i = 0; i < rawFiles.length; i++) {
      const uploadFile = rawFiles[i];
      const responseFile = responseFiles[i];
      putRequests.push(
        axios.put(responseFile.uploadUrl, uploadFile.rawFile, {
          headers: {
            'Content-Type': responseFile.contentType,
          },
        })
      );
    }
    await axios.all(putRequests);
    return uploadRequest;
  }
  return;
};
